import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchCampaignsMiniEntity } from '../../domain/entities/BranchCampaignsMiniEntity'

export class BranchCampaignsMiniModel extends BranchCampaignsMiniEntity {
  constructor(dataDto: BranchCampaignsMiniEntity) {
    super()
    mapEntityProperties<BranchCampaignsMiniEntity>(this, dataDto)
  }
}
